<template>
    <div class="modal fade" :id="'transactionModal'+_uid" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Merchant Transaction</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-if="transaction==1">
                    <h5>For continue this Transaction you will be redirected out of our website, Are you sure to continue?</h5>
                    <button class="btn btn-primary" @click="processingTransaction">Accept</button>
                </div>
                <div v-else-if="transaction == 2">
                    <h5>The transaction is in process. Please wait <i class="fas fa-spinner fa-pulse"></i>  </h5>
                    <p> <button class="btn btn-danger" @click="cancelTransaction">Cancel</button> </p>
                </div>
                <div v-else-if="transaction == 3">
                    <h5>The Transaction has been completed successfully</h5>
                    <p> <button class="btn btn-primary" @click="cancelTransaction">Exit</button> </p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /**
        tag
        name: ks-ui-transaction-modal
        description: ui transaction modal
    **/
    name: 'ks-ui-transaction-modal',
    data(){
        return {
            form:null,
            transaction: 0
        }
    },
    methods:{
        initTransaction(action, inputs, target = "_self", method="POST" ){
            try{
                let form = document.createElement("form");
                for(let prop in inputs){
                    let inputForm = document.createElement("input"); 
                    inputForm.value=inputs[prop];  
                    inputForm.name=`${prop}TF_${this._uid}`;
                    inputForm.type="hidden";
                    form.appendChild(inputForm); 
                }

                form.method = method;
                form.action = action; 
                form.target = target;
                this.form = form;
                document.body.appendChild(this.form);
                if(target === '_self'){
                    this.processingTransaction();
                } else{
                    this.transaction = 1;
                    $("#transactionModal" + this._uid).modal({backdrop: 'static', keyboard: false});
                    $("#transactionModal" + this._uid).modal('show');
                }                
            }catch(err){
                console.log('KS-APP: ',err);
            }
        },
        processingTransaction(){
            this.form.submit();
            this.transaction = 2;
        },
        successTransaction(){
            this.transaction = 3;
        },
        cancelTransaction(){
            $('#transactionModal' + this._uid).modal('hide');
            this.transaction = 0;
        }  
    }
}
</script>

